import React from 'react';

/**
 * Phase 5.0B FINAL — decorative goal frame overlay.
 *
 * Presentation only. Positioned absolutely inside a relative parent
 * (GameBoard container). Zero pointer events. Never obscures GK.
 */
export default function GoalFrame({ orientation = 'top' }) {
  return (
    <img
      src="/gameplay/goal_frame_default.svg"
      alt=""
      aria-hidden
      className={
        'kk-goal-frame '
        + (orientation === 'top' ? 'kk-goal-frame--top' : 'kk-goal-frame--bottom')
      }
    />
  );
}
